<template>
  <div class="animated fadeIn">
    <div class="row">
      <div class="col-12 pt-3 pb-3 pl-4">
        <h3><i class="fas fa-chart-line"></i> Relatórios - Movimentação de Cards</h3>
      </div>
    </div>

    <Tables
      ref="tableGrid"
      :columns="columns"
      :showSearch="true"
      :showReload="false"
      :showTipFooter="false"
      v-on:Search="onShowSearch"
      v-on:Load="onLoad"
      v-on:Reload="onLoad"
    >
      <template slot="table-header-buttons">
        <a
          href="javascript:void(0);"
          v-b-tooltip.hover
          :title="'Exportar'"
          @click="showConfirmationModal"
        >
          <i
            class="fas fa-file-excel text-third"
            style="font-size: 15px"
          ></i>
        </a>
        <a
          href="javascript:void(0);"
          id="popover-report-collumn"
        >
          <i
            class="fas fa-columns text-third"
            style="font-size: 15px"
          ></i>
        </a>
        <b-popover
          target="popover-report-collumn"
          triggers="hover"
          placement="bottomleft"
        >
          <template #title>Adicionar/ Remover Colunas</template>
          <div class="pb-3">
            <div
              class="pb-3"
              style="font-size: 9px"
            >
              Clique para adicionar/ remover colunas na grid
            </div>
            <div class="pl-4">
              <div
                v-for="(item, index) in columnsOpt"
                :key="index"
              >
                <b-form-checkbox
                  v-model="item.value"
                  name="check-button"
                  switch
                  @change="setVisibleColumns"
                >
                  {{ item.label }}
                </b-form-checkbox>
              </div>
            </div>
          </div>
        </b-popover>
      </template>
      <tr
        v-for="obj in this.objList"
        v-bind:key="obj.cardId"
      >
        <template>
          <TableColumn
            v-if="columnsOpt[0].value"
            :IsTextNoLink="true"
            :status="1"
            :value="obj.nomeAssociado ? obj.nomeAssociado.toUpperCase() : ' '"
          />
          <TableColumn
            v-if="columnsOpt[1].value"
            :IsTextNoLink="true"
            :status="1"
            :value="obj.cpfCnpj ? onFormatDocument(obj.cpfCnpj) : ' '"
          />
          <TableColumn
            v-if="columnsOpt[2].value"
            :IsTextNoLink="true"
            :status="1"
            :value="obj.tipoPessoa ? obj.tipoPessoa : '-'"
          />
          <TableColumn
            v-if="columnsOpt[3].value"
            :IsTextNoLink="true"
            :status="1"
            :value="obj.nomePa ? obj.nomePa : '-'"
          />
          <TableColumn
            v-if="columnsOpt[4].value"
            :IsTextNoLink="true"
            :status="1"
            :value="obj.nomeCrm ? obj.nomeCrm : '-'"
          />
          <TableColumn
            v-if="columnsOpt[5].value"
            :IsTextNoLink="true"
            :status="1"
            :value="obj.nomeQuadro ? obj.nomeQuadro : '-'"
          />
          <TableColumn
            v-if="columnsOpt[6].value"
            :IsTextNoLink="true"
            :status="1"
            :value="obj.nomeColuna ? obj.nomeColuna : '-'"
          />
          <TableColumn
            v-if="columnsOpt[7].value"
            :IsTextNoLink="true"
            :status="1"
            :value="obj.inicioFase ? formatDateAndTime(obj.inicioFase) : '-'"
          />
          <TableColumn
            v-if="columnsOpt[8].value"
            :IsTextNoLink="true"
            :status="1"
            :value="obj.fimFase ? formatDateAndTime(obj.fimFase) : '-'"
          />
          <TableColumn
            v-if="columnsOpt[9].value"
            :IsTextNoLink="true"
            :status="obj.tempoPermanenciaMinutos < 0 ? 0 : 1"
            :value="obj.tempoPermanenciaMinutos !== null ? obj.tempoPermanenciaMinutos : '-'"
            :class="{ 'text-danger font-weight-bold': obj.tempoPermanenciaMinutos < 0 }"
          />
          <TableColumn
            v-if="columnsOpt[10].value"
            :IsTextNoLink="true"
            :status="1"
            :value="obj.nomeResponsavel ? obj.nomeResponsavel.toUpperCase() : '-'"
          />
        </template>
      </tr>
    </Tables>

    <SidebarRelatorioMovimentacao ref="sidebar" @search="onSearch" :isSearching="isSearching" />

    <AddConfirmation
      ref="confirmation-modal"
      :saveFunction="onExportExcel"
      :warnText="'Deseja extrair o relatório em arquivo Excel?'"
    />
  </div>
</template>

<script>
import Tools from '@/components/tools/Tools.js'
import ReportMovimentacaoRepository from '@/shared/http/repositories/reports/movimentacao/ReportMovimentacaoRepository.js'
import ActionsForm from '@/shared/mixins/actionsForm'
import { loading, toast } from '@/shared/utils/UIHelper'
import { CookieUtils } from '@/shared/utils/cookiesUtils'
import SidebarRelatorioMovimentacao from './search/SidebarRelatorioMovimentacao.vue'
import AddConfirmation from '@/components/UI/confirmation/addConfirmation.vue'

export default {
  name: 'ReportMovimentacao',
  mixins: [ActionsForm],
  components: {
    SidebarRelatorioMovimentacao,
    AddConfirmation
  },
  data () {
    return {
      filters: null,
      columns: [],
      isSearching: false,
      columnsOpt: [
        { value: true, label: 'NOME', key: 'nomeAssociado' },
        { value: true, label: 'CPF/CNPJ', key: 'cpfCnpj' },
        { value: true, label: 'TIPO PESSOA', key: 'tipoPessoa' },
        { value: true, label: 'PA', key: 'nomePa' },
        { value: true, label: 'CRM', key: 'nomeCrm' },
        { value: true, label: 'QUADRO', key: 'nomeQuadro' },
        { value: true, label: 'COLUNA', key: 'nomeColuna' },
        { value: true, label: 'INÍCIO FASE', key: 'inicioFase' },
        { value: true, label: 'FIM FASE', key: 'fimFase' },
        { value: true, label: 'TEMPO (MIN)', key: 'tempoPermanenciaMinutos' },
        { value: true, label: 'RESPONSÁVEL', key: 'nomeResponsavel' }
      ]
    }
  },
  methods: {
    onSearch (filters) {
      this.filters = filters
      this.$refs.tableGrid.Clear()
      this.$nextTick(() => {
        this.onLoadAll()
      })
    },
    onLoad () {
      this.setVisibleColumns()
      if (this.filters) {
        this.onLoadAll()
      }
    },
    onLoadAll () {
      this.isSearching = true
      loading.push()

      const grid = this.$refs.tableGrid
      const page = grid ? grid.pagingIndex : 0
      const size = grid ? grid.pagingLimit : 10

      ReportMovimentacaoRepository.GetAll(this.filters, page, size)
        .then((response) => {
          const total = response.data && response.data.totalElements ? response.data.totalElements : 0

          if (total === 0) {
            toast.info('Nenhum registro encontrado para os parâmetros informados.', 'Informação')
          } else if (page === 0) {
            toast.success(`${total} registro(s) encontrado(s).`, 'Sucesso')
          }

          this.onResultGrid(response)
        })
        .catch((error) => {
          this.handleReportError(error)
        })
        .finally(() => {
          this.isSearching = false
        })
    },
    onShowSearch () {
      this.$root.$emit('bv::toggle::collapse', 'sidebar-1')
    },
    setVisibleColumns () {
      this.columns = []
      for (let i = 0; i < this.columnsOpt.length; i++) {
        if (this.columnsOpt[i].value) {
          this.columns.push(this.columnsOpt[i].label)
        }
      }
    },
    onFormatDocument (document) {
      return Tools.formatCpfCnpj(document, Tools.checkDocumentType(document))
    },
    formatDateAndTime (rawDate) {
      const date = new Date(rawDate)
      const day = date.getDate().toString().padStart(2, '0')
      const month = (date.getMonth() + 1).toString().padStart(2, '0')
      const year = date.getFullYear()
      const hours = date.getHours().toString().padStart(2, '0')
      const minutes = date.getMinutes().toString().padStart(2, '0')

      return `${day}/${month}/${year} às ${hours}:${minutes}`
    },
    handleReportError (error) {
      loading.pop()

      let errorMessage = ''
      if (error && error.data) {
        if (error.data.message) {
          errorMessage = error.data.message
        } else if (Array.isArray(error.data.errors) && error.data.errors.length > 0) {
          errorMessage = error.data.errors[0].message || error.data.errors[0]
        } else if (typeof error.data === 'string') {
          errorMessage = error.data
        }
      }

      if (errorMessage && errorMessage.includes('período máximo permitido')) {
        const match = errorMessage.match(/período máximo permitido é de (\d+) dias/i)
        if (match && match[1]) {
          const maxDays = parseInt(match[1], 10)
          if (this.$refs.sidebar) {
            this.$refs.sidebar.maxDays = maxDays
          }
        }
        toast.error(errorMessage, 'Atenção')
      } else {
        this.onException(error)
      }
    },
    showConfirmationModal () {
      this.$refs['confirmation-modal'].showModal()
    },
    onExportExcel () {
      if (!this.filters) {
        toast.warning(
          'Por favor, execute a pesquisa antes de exportar o relatório.',
          'Atenção!'
        )
        return
      }

      if (!this.objList || this.objList.length === 0) {
        toast.warning(
          'Não há dados para exportar. Execute a pesquisa com filtros que retornem resultados.',
          'Atenção!'
        )
        return
      }

      const cookieName = 'exportMovimentacaoInProgress'

      if (CookieUtils.isExportInProgress(cookieName)) {
        toast.warning(
          'A exportação já está em execução ou foi interrompida recentemente. Tente novamente mais tarde.',
          'Atenção!'
        )
        return
      }

      CookieUtils.startExport(cookieName)
      loading.push()

      const columnsFilter = {
        incluirNome: this.columnsOpt[0].value,
        incluirCpfCnpj: this.columnsOpt[1].value,
        incluirTipoPessoa: this.columnsOpt[2].value,
        incluirPa: this.columnsOpt[3].value,
        incluirCrm: this.columnsOpt[4].value,
        incluirQuadro: this.columnsOpt[5].value,
        incluirColuna: this.columnsOpt[6].value,
        incluirInicioFase: this.columnsOpt[7].value,
        incluirFimFase: this.columnsOpt[8].value,
        incluirTempoPermanencia: this.columnsOpt[9].value,
        incluirResponsavel: this.columnsOpt[10].value
      }

      ReportMovimentacaoRepository.Export(this.filters, columnsFilter)
        .then((response) => {
          Tools.downloadBase64File(response.data, 'relatorio_movimentacao.xlsx')
          toast.success('Relatório exportado com sucesso!', 'Sucesso')
        })
        .catch((error) => {
          console.error('Erro ao exportar relatório:', error)
          toast.error('Não foi possível gerar o arquivo. Tente novamente.', 'Erro')
        })
        .finally(() => {
          loading.pop()
          CookieUtils.completeExport(cookieName)
        })
    }
  }
}
</script>

<style scoped>
.popover-header {
  background-color: #04a791;
  color: #eceff1;
}
</style>



// WEBPACK FOOTER //
// src/views/private/reports/movimentacao/ReportMovimentacao.vue